import * as labelManage from '../services/labelManage';

const getIndex = (list, attr) => {
  for (let i = 0; i < list.length; i++) {
    if (list[i].id === attr) {
      return i;
    }
  }
  return -1;
};
const getTreeData = (data) => {
  for (let i of data) {
    if (i.type !== 7) {
      const index = getIndex(data, i.id);
      data.splice(index, 1);
      getTreeData(data);
    } else {
      i.children && i.children.length > 0 && getTreeData(i.children);
    }
  }
};

export default {
  namespace: 'labelManage',

  state: {
    tagMember: [],
    tagTree: [],
    status: null,
    favoriteList: [],
    isFavorite: null,
    tagHistory: [],
    isDownload: null,
    tagInfo: {},
    checked: true,
  },

  effects: {
    //维护checked的状态并获取数据
    *checkedTreeData({ payload: { checked } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          checked: !checked,
        },
      });
    },
    //标签人数
    *getQueryTagMember({ payload: { values } }, { call, put }) {
      const response = yield call(labelManage.getQueryTagMember, values);
      yield put({
        type: 'save',
        payload: {
          tagMember: response?.data,
        },
      });
    },
    // 标签树查询
    *getQueryTagTree({ payload: { values }, callback }, { call, put }) {
      const response = yield call(labelManage.getQueryTagTree, values);
      yield put({
        type: 'save',
        payload: {
          tagTree: response?.data || [],
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 收藏列表
    *getQueryFavorite({ payload: { values } }, { call, put }) {
      const response = yield call(labelManage.getQueryFavorite, values);
      yield put({
        type: 'save',
        payload: {
          favoriteList: response?.data || [],
        },
      });
    },
    // 计算状态
    *updateComputeStatus({ payload: { values }, callback }, { call, put }) {
      const response = yield call(labelManage.updateComputeStatus, values);
      yield put({
        type: 'save',
        payload: {
          status: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 标签停用启用按钮
    *updateStatus({ payload: { values }, callback }, { call, put }) {
      const response = yield call(labelManage.updateStatus, values);
      yield put({
        type: 'save',
        payload: {
          status: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 收藏按钮
    *handleFavorite({ payload: { values }, callback }, { call, put }) {
      const response = yield call(labelManage.handleFavorite, values);
      yield put({
        type: 'save',
        payload: {
          isFavorite: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 标签历史
    *getQueryTagHistory({ payload: { values } }, { call, put }) {
      const response = yield call(labelManage.getQueryTagHistory, values);
      yield put({
        type: 'save',
        payload: {
          tagHistory: response?.data,
        },
      });
    },
    // 标签的下载按钮
    *getDownloadTagMember({ payload: { values }, callback }, { call, put }) {
      const response = yield call(labelManage.getDownloadTagMember, values);
      yield put({
        type: 'save',
        payload: {
          isDownload: response?.data,
        },
      });
      callback(response);
    },
    // 查询单个标签基本信息
    *getQueryTagInfo({ payload: { values } }, { call, put }) {
      const response = yield call(labelManage.getQueryTagInfo, values);
      yield put({
        type: 'save',
        payload: {
          tagInfo: response?.data,
        },
      });
    },
    //查询标签树
    *getQueryTagTreeCL({ payload: { values } }, { call, put }) {
      const response = yield call(labelManage.getQueryTagTree, values);
      const treeList = response.data;
      getTreeData(treeList);
      yield put({
        type: 'save',
        payload: {
          labelDirectoryList: treeList,
        },
      });
    },
    //查询标签树
    *getQueryFileList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(labelManage.getQueryFileList, values);
      const responseTag = yield call(labelManage.getQueryTagOperatorValue, []);
      const treeList = response.data;
      yield put({
        type: 'save',
        payload: {
          ruleLabelDirectoryList: treeList,
          queryTagOperatorValue: responseTag.data,
          treeDataRefresh: new Date(),
        },
      });
      response.code === 0 && callback && callback(response.data);
    },
    //新增集合标签
    *postInsertOrUpdateTagAndCollectionAndRule(
      { payload: { values }, callback },
      { call },
    ) {
      const response = yield call(
        labelManage.postInsertOrUpdateTagAndCollectionAndRule,
        values,
      );
      callback && callback(response?.code);
    },
    //集合标签详情
    *getQueryCollectionTagInfo({ payload: { values }, callback }, { call }) {
      const response = yield call(
        labelManage.getQueryCollectionTagInfo,
        values,
      );
      response.code === 0 && callback && callback(response.data);
    },
    //标签目录的修改和新增
    *postInsertOrUpdate({ payload: { values }, callback }, { call, put }) {
      const response = yield call(labelManage.postInsertOrUpdate, values);
      if (response.code === 0) {
        const response1 = yield call(labelManage.getQueryTagTree, {});
        const treeList = response1.data;
        getTreeData(treeList);
        yield put({
          type: 'save',
          payload: {
            labelDirectoryList: treeList,
          },
        });
        // eslint-disable-next-line callback-return
        response1.code === 0 && callback && callback();
      }
    },
    //标签目录的删除
    *postDeleteTagCatalogue({ payload: { values }, callback }, { call, put }) {
      const response = yield call(labelManage.postDeleteTagCatalogue, values);
      if (response.code === 0) {
        const response1 = yield call(labelManage.getQueryTagTree, {});
        const treeList = response1.data;
        getTreeData(treeList);
        yield put({
          type: 'save',
          payload: {
            labelDirectoryList: treeList,
          },
        });
        // eslint-disable-next-line callback-return
        response1.code === 0 && callback && callback();
      }
    },
    *deleteLabel({ payload: { values }, callback }, { call }) {
      const response = yield call(labelManage.deleteLabel, values);
      callback(response);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          [
            '/profile/label_manage/statistics',
            '/profile/label_manage/collection_label',
            '/profile/label_manage/import',
            '/profile/label_manage/sql',
            '',
          ].includes(props.pathname)
        ) {
          dispatch({
            type: 'save',
            payload: {
              tagMember: [],
              tagTree: [],
              status: null,
              favoriteList: [],
              isFavorite: null,
              tagHistory: [],
              isDownload: null,
              tagInfo: {},
              checked: true,
            },
          });
        }
      });
    },
  },
};
